export const formatCurrency = (amount: number | string, isRound?: boolean) =>
  `${Number(amount) < 0 ? '- ' : ''}$${Math.abs(Number(amount))
    .toFixed(isRound && Number.isInteger(amount) ? 0 : 2)
    .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}`;

/**
 * Formats a phone number by removing parentheses and spaces, and replacing dots with hyphens.
 * @param {string} value - The phone number to format.
 * @returns {string} The formatted phone number.
 */
export const formatPhoneNumbers = (value: string = '') =>
  value?.replace(/[().]/g, '').replace(/ /g, '-').replace(/\./g, '-');

/**
 * Formats a phone number into from "333333333" "333-333-3333" format.
 * @param {string} value - The phone number to format.
 * @returns {string} The formatted phone number.
 */
export const formatPhoneToFormat = (value: string = ''): string => {
  const cleanedValue = value.replace(/[^\d]/g, '');
  return `${cleanedValue.slice(0, 3)}-${cleanedValue.slice(
    3,
    6
  )}-${cleanedValue.slice(6, 10)}`;
};

/**
 * Get a lowest number of two.
 * @returns {number} The lowest number.
 */
export const getCurrentPrice = (first: number, second?: number): number =>
  second ? Math.min(first, second) : first;

/**
 * Formats client reward/loyalty points with thousands separators.
 * Coerces string payloads and non-finite values to a safe integer (Sencha parity).
 */
export const formatRewardPoints = (
  value: number | string | null | undefined
): string => {
  let n: number;
  if (typeof value === 'number' && Number.isFinite(value)) {
    n = Math.trunc(value);
  } else if (typeof value === 'string' && value.trim() !== '') {
    n = Math.trunc(Number(value));
  } else {
    n = 0;
  }
  if (!Number.isFinite(n)) n = 0;
  return n.toLocaleString('en-US');
};
